export default __webpack_public_path__ + "static/media/watson-7.7d8b1612.png";